export default {
  methods: {
    getSubdomain() {
      let subdomain = window.location.host.split('.')[0].toLowerCase();
      subdomain = /^\d+&/.test(subdomain) ? 'app' : subdomain;

      const allowedSubdomains = [
        'alpha',
        'atallorder',
        'bluebox',
        'captive',
        'contentino',
        'creativecentury',
        'dw',
        'eagle',
        'encore',
        'fifthseason',
        'france24',
        'fvs',
        'gate23',
        'horizon',
        'img',
        'inflightflix',
        'lionsgate',
        'lms',
        'moment',
        'pictureworks',
        'rave',
        'ricochet',
        'safran',
        'silkroute',
        'skeye',
        'tsi',
        'uplay',
      ];

      return allowedSubdomains.includes(subdomain) ? subdomain : 'app';
    },
  },
};
